import gql from 'graphql-tag'

const assenze = gql`
  query assenze (
    $limit: Int!,
    $offset: Int,
    $where: AssenzeFilterInput
  ) {
    assenze (
      limit: $limit,
      offset: $offset,
      where: $where
    ) {
      totalCount
      nodes {
        id
        utenteId
        utente {
          id
          nome
        }
        daDataOra
        aDataOra
        descrizione
        flagOccupato
      }
    }
  }
`

export default assenze


// WEBPACK FOOTER //
// ./src/graphql/queries/assenze.js